module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/address/postcode.js
// module id = 2766
// module chunks = 2